import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        api: "",
    },
    getters: {},
    mutations: {
        setApi(state , api) {
            state.api = api;
        }
    }
});

export default store;


// WEBPACK FOOTER //
// ./src/vuex/store.js